import { MainColor } from '../palette';

export const defaultClientConfig = {
  text: {
    default: 'navy95' as MainColor,
    content: 'coolGrey60' as MainColor,
    navigation: 'navy80' as MainColor,
  },
  background: {
    default: 'white95' as MainColor,
    bars: 'coolGrey5' as MainColor,
    form: 'white95' as MainColor,
    appBarOption: 'white100' as MainColor,
    formProperty: 'coolGrey5' as MainColor,
    disabled: 'coolGrey20' as MainColor,
  },
  border: {
    default: 'coolGrey30' as MainColor,
    light: 'coolGrey10' as MainColor,
    formProperty: 'coolGrey10' as MainColor,
  },
  statuses: {
    default: 'coolGrey50' as MainColor,
    information: 'navy50' as MainColor,
    warning: 'orange50' as MainColor,
    error: 'red50' as MainColor,
    success: 'green50' as MainColor,
  },
};

export type DefaultClientConfig = typeof defaultClientConfig;
